__webpack_require__.p = "/mi-assets/mi-static/mi-trc-renderer/web-rel-26.4.2-775056f-8567/_next/";